/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './update-password.component.scss.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '../../../../app/auth/update-password/update-password.component';
import * as import3 from '../../user-management/user-password/user-password-form/user-password-form.component.ngfactory';
import * as import4 from '../../../../app/user-management/user-password/user-password-form/user-password-form.component';
import * as import5 from '../../../../app/api/user.service';
import * as import6 from '../../../../app/notification/notification.service';
import * as import7 from '../../../../app/spinner/spinner.service';
import * as import8 from '@angular/router';
const styles_UpdatePasswordComponent:any[] = [import0.styles];
export const RenderType_UpdatePasswordComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_UpdatePasswordComponent,
  data: {}
}
);
export function View_UpdatePasswordComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),30,'div',[
      [
        'class',
        'update-password'
      ]
      ,
      [
        'id',
        'page-signup-organisation'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),5,'header',[[
        'id',
        'header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),2,'a',[
      [
        'href',
        '/'
      ]
      ,
      [
        'style',
        'background: none;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'img',[
      [
        'alt',
        'Auslan Connections'
      ]
      ,
      [
        'height',
        '46'
      ]
      ,
      [
        'name',
        'auslanLogo'
      ]
      ,
      [
        'src',
        'assets/img/auslan-logo.png'
      ]
      ,
      [
        'width',
        '72'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),5,'header',[[
        'id',
        'header-mobile'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),2,'a',[
      [
        'href',
        '/'
      ]
      ,
      [
        'style',
        'background: none;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'img',[
      [
        'alt',
        'Auslan Connections'
      ]
      ,
      [
        'height',
        '46'
      ]
      ,
      [
        'name',
        'auslanLogo'
      ]
      ,
      [
        'src',
        'assets/img/auslan-logo.png'
      ]
      ,
      [
        'width',
        '72'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),13,'section',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),7,'header',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'h1',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Update Password'])),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Fields with * are required'])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-user-password-form',([] as any[]),(null as any),[[
        (null as any),
        'success'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import2.UpdatePasswordComponent = v.component;
      if (('success' === en)) {
        const pd_0:any = ((<any>co.onSubmit()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import3.View_UserPasswordFormComponent_0,import3.RenderType_UserPasswordFormComponent)),
    import1.ɵdid(49152,(null as any),0,import4.UserPasswordFormComponent,[
      import5.UserService,
      import6.NotificationServiceBus,
      import7.SpinnerService,
      import8.ActivatedRoute
    ]
      ,{resetPasswordMsg: [
        0,
        'resetPasswordMsg'
      ]
    },{success: 'success'}),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    const currVal_0:any = true;
    ck(v,28,0,currVal_0);
  },(null as any));
}
function View_UpdatePasswordComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'ng-component',([] as any[]),(null as any),(null as any),(null as any),View_UpdatePasswordComponent_0,RenderType_UpdatePasswordComponent)),
    import1.ɵdid(245760,(null as any),0,import2.UpdatePasswordComponent,[
      import5.UserService,
      import8.Router
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const UpdatePasswordComponentNgFactory:import1.ComponentFactory<import2.UpdatePasswordComponent> = import1.ɵccf('ng-component',import2.UpdatePasswordComponent,View_UpdatePasswordComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/auth/update-password/update-password.component.ngfactory.ts